import { useEffect, useState } from 'react';
const CountDownTimer = (props) => {
  const timeInSeconds = 600;

  const countDownDate = () => {
    const d = new Date();
    d.setSeconds(d.getSeconds() + timeInSeconds);
    return d;
  };

  const [counterTime, setCounterTime] = useState(countDownDate());

  const [timeLeft, setTimeLeft] = useState(counterTime - new Date().getTime());

  useEffect(() => {
    if (props.isRestartTimer) {
      setCounterTime(countDownDate());
      props.resetTimerSuccess(false);
    }
    const intervalId = setInterval(() => {
      const curr = new Date().getTime();
      const distance = counterTime - curr;
      setTimeLeft(distance);
      if (distance < 0) {
        setTimeLeft(0);
      } else {
        setTimeLeft(distance);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [counterTime, timeLeft, props.isRestartTimer, props]);

  const toHHMMSS = (secs) => {
    const hours = Math.floor((secs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes = Math.floor((secs % (1000 * 60 * 60)) / (1000 * 60)),
      seconds = Math.floor((secs % (1000 * 60)) / 1000);
    if (seconds < 0) {
      props.getCountDownTime(0);
    }
    return [hours, minutes, seconds]
      .map((v) => (v < 10 ? '0' + v : v))
      .filter((v, i) => v !== '00' || i > 0)
      .join(':');
  };

  return toHHMMSS(timeLeft);
};
export default CountDownTimer;
